// Acrescimo do cartao sobre o preco PIX — FONTE UNICA do fator (antes duplicado em
// produtos.routes.ts e ProdutoForm.tsx). O preco de cartao da loja e DERIVADO do pix:
// cartao = pix * (1 + 5,25%). Os ~5,25% cobrem taxa da maquininha + imposto — NAO sao
// margem da loja, por isso a comissao do vendedor sai sobre o pix (ver project_comissao_base_pix).
export const ACRESCIMO_CARTAO_PCT = 5.25;

// 1,0525 — divisor pra voltar do cartao pro pix exato (cartao ÷ FATOR = pix).
export const FATOR_CARTAO = 1 + ACRESCIMO_CARTAO_PCT / 100;

// Pix -> cartao: floor a 4 casas (o preco_cartao do produto cai com casa alem do centavo,
// ver DA-148). Mesma formula que vivia em produtos.routes.ts / ProdutoForm.tsx.
export function calcPrecoCartao(precoPix: number): number {
  return Math.floor(precoPix * FATOR_CARTAO * 10000) / 10000;
}

// Cartao -> pix: usado pela base de comissao (cartao 1x ou parcelado -> valor pix).
export function precoPixDeCartao(valorCartao: number): number {
  return valorCartao / FATOR_CARTAO;
}
